import { ButtonMain } from '@/modules/common/components/button';
import { createOfferFoo } from '@/modules/common/utils/create-offer.function';
import {
  BestPriceBuyerItem,
  getBestMarketPricesTabFx,
  IBestPriceBagItem,
} from '@/modules/mixing/store/analytical-mixing.store';
import {
  $selectedRecipeStore,
  setMarkeredMixes,
} from '@/modules/mixing/store/recipes.store';
import { fetchWarehousesForMixingDataFx } from '@/widgets/recipe/model';
import classNames from 'classnames';
import { useStore } from 'effector-react';
import styles from './index.module.sass';
import useScrollRestoration from '@/shared/hooks/useScrollRestoration';

interface IProps {
  offer?: BestPriceBuyerItem;
  data: IBestPriceBagItem;
  action: {
    type: 'mix' | 'sell' | 'busy';
    onClick: () => void;
  };
  TARGET_MOISTURE: number;
  setModalViewOnly: (val: boolean) => void;
  setModalOpen: (val: boolean) => void;
  setActionState: (val: 'drain' | 'hydrate' | null) => void;
  moistureChangesDensity?: boolean;
  setActiveTab: (val: number) => void;
  loading: boolean;
  setViewPresellWarning: (val: boolean) => void;
}

export const ActionArea = ({
  offer,
  data,
  action,
  TARGET_MOISTURE,
  setModalViewOnly,
  setModalOpen,
  setActionState,
  moistureChangesDensity,
  setActiveTab,
  loading,
  setViewPresellWarning,
}: IProps) => {

  const activeWarehouse = useStore($selectedRecipeStore);
  const isStationary = activeWarehouse?.type === '1';

  const saveScrollPosition = useScrollRestoration(!loading, 'contentAreaScrollable');

  const sellSeparateClick = async () => {
    saveScrollPosition();
    if (
      action.type === 'sell' &&
      offer &&
      TARGET_MOISTURE === +data.values.humidity &&
      (!data.mixes || data.mixes.length === 0)
    ) {
      await createOfferFoo({
        action: null,
        price: offer.price_per_ton,
        weight: data.weight,
        weight_gain_tons: 0,
        sleeveData: data,
        onCancel: () => {
          setModalViewOnly(false);
          setModalOpen(false);
          setActionState(null);
        },
        offer,
        warehouseId: Number(activeWarehouse?.id),
        additionalData: {
          mix_id: null,
          mixing_profit: null,
          price_logistic: data.freight_cost_after_moisture_mod,
          initial_price_logistic: offer.freight_price,
          price_netto: offer.netto,
          price_all: offer.price_all,
          is_remnants: false,
          action_place: null,
        },
        initial_weight_gain_tons: +data.weight_gain_tons,
      });
      await getBestMarketPricesTabFx({
        trade: true,
        moistureChangesDensity,
      });
      await fetchWarehousesForMixingDataFx({});
    } else if (
      action.type === 'sell' &&
      (!data.mixes || data.mixes.length === 0)
    ) {
      if (data.mixes?.length === 0) {
        setActionState(
          TARGET_MOISTURE < +data.values.humidity ? 'drain' : 'hydrate',
        );
      }
      setModalViewOnly(false);
      setModalOpen(true);
      return;
    } else if (
      action.type === 'sell' &&
      data.mixes &&
      data.mixes.length > 0
    ) {
      setModalViewOnly(false);
      //setActionState(null);
      setViewPresellWarning(true);
      setModalOpen(true);
    } else {
      action.onClick();
      await getBestMarketPricesTabFx({
        trade: true,
        moistureChangesDensity,
      });
    }
  };

  return (
    <div
      className={classNames(styles.actionArea, action.type === 'mix' && styles.mixArea)}
    >
      {action?.type === 'busy' ? (
        <div className={styles.busyAction}>
          <span className={styles.busyLabel}>{isStationary ? 'объем' : 'рукав'} участвует в сделке</span>
          <span
            className={styles.busyButton}
            onClick={() => {
              action.onClick();
            }}
          >
            отменить сделку
          </span>
        </div>
      ) : action.type === 'sell' ? (
        <>
          <ButtonMain
            onClick={sellSeparateClick}
            className={styles.sellAction}
            label={'продать отдельно'}
          />
          {data.mixes.length > 0 ? (
            <ButtonMain
              onClick={async () => {
                setMarkeredMixes(data.mixes.map((item) => +Object.entries(item)[0][0]));
                setActiveTab(1);
              }}
              className={styles.mixAction}
              label={'замиксовать'}
            />
          ) : (
            ''
          )}
        </>
      ) : action.type === 'mix' ? (
        <ButtonMain
          onClick={async () => {
            setMarkeredMixes(data.mixes.map((item) => +Object.entries(item)[0][0]));
            setActiveTab(1);
          }}
          className={styles.mixAction}
          label={'замиксовать'}
        />
      ) : (
        ''
      )}
    </div>
  );
};
